import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const Adultosmayores = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Atención de las y los Adultos Mayores</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>

                <h6 className='description' style={{ marginTop: '20px' }}>
                Que el Programa de Atención a Personas Adultas Mayores, tiene como objeto atender las necesidades y demandas de las personas mayores en el Estado de Hidalgo, con la expectativa de favorecer el bienestar biopsicosocial en la vejez e incrementar la calidad de vida durante el proceso de envejecimiento, a través de la implementación de la atención centrada en la persona y servicios gerontológicos orientados al fomento del envejecimiento digno, positivo y exitoso; así como, a la investigación y enseñanza en gerontología. El Modelo Hidalgo de Atención Gerontológica está compuesto por los principios de Dignidad, Independencia, Autocuidado, Participación, Autonomía, Integralidad, Bienestar y Protección Social, encaminados a dar cumplimiento a los derechos humanos de las personas mayores, dicho esquema de atención está estructurado con acciones y estrategias dirigidas a prevenir la fragilidad y vulnerabilidad, fomentar el mantenimiento de la salud, propiciar la reintegración social, prolongar la funcionalidad y mejorar las condiciones de vida.
                </h6>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)'  }}>Objetivo del Programa</h5>
                <p>
                Brindar atención integral y ambulatoria a las Personas Adultas Mayores mediante acciones gerontológicas para mejorar su bienestar.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)'  }}>Población Objetivo</h5>
                <p>
                El 7.6% (24,010) de las personas mayores que radiquen, estén domiciliadas o en tránsito en el Estado de Hidalgo. 
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)'  }}>Cobertura</h5>
                <p>
                La cobertura de los apoyos y acciones gerontológicas operará a nivel estatal, en la capacidad que permita la infraestructura y presupuesto del programa.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)'  }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)'  }}>Áreas de atención</h5>
                
                <p>  
                <ul>
                <li><b>Secretaría de Bienestar en Inclusión Social</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                <li><b>Dirección General del Instituto de las y los Adultos Mayores del Estado de hidalgo</b></li>
                <dd>Parque Hidalgo 103, Parque Hidalgo, 42000 Pachuca de Soto, Hgo.</dd>
                </ul>
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)'  }}>Personas Responsables del Programa</h5>
                <p>
                <ul>
                <li>Lic. Ariadna Penélope Apodaca Sinsel                    
                </li>
                </ul>
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)'  }}>Teléfono de Contacto</h5>
                <p>
                
                771 719 33 68, 771 376 90 41 y 771 397 55 36                  

                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}><strong>Sitio Web</strong></h5>
                <p>
                <a
                href='https://adultosmayores.hidalgo.gob.mx/'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Instituto de las y los Adultos Mayores del Estado de Hidalgo</a>
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}><strong>Reglas de Operación</strong></h5>
                
                <ul>
                <li>  
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Atenci%C3%B3n_Adultos_Mayores_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2025</a>
                </li>
                <li>  
                <a
                href='/https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_IAAMEH_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2024</a>
                </li>
                </ul>
                <p>
                </p>
                
                <p>
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Adultosmayores;